// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-emZ8L0","bubble":"bubble-aFO9mx","title":"title-bpiEtk","description":"description-_yICzv","caret":"caret-jxcRur"};